<template>
    <div class="object-storage-management">
        <a-card title="对象存储配置" class="storage-config-card">
            <template #extra>
                <a-button type="primary" @click="saveConfig" :loading="saving">
                    <SaveOutlined />
                    保存配置
                </a-button>
            </template>

            <a-form :model="storageConfig" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @finish="saveConfig">
                <!-- 存储服务选择 -->
                <a-form-item label="存储服务类型" name="provider">
                    <a-select v-model:value="storageConfig.provider" @change="handleProviderChange"
                        placeholder="请选择存储服务">
                        <a-select-option value="supabase">Supabase Storage</a-select-option>
                        <a-select-option value="tencent">腾讯云 COS</a-select-option>
                    </a-select>
                </a-form-item>

                <!-- Supabase Storage 配置 -->
                <template v-if="storageConfig.provider === 'supabase'">
                    <a-divider>Supabase Storage 配置</a-divider>
                    <a-form-item label="项目 URL" name="supabaseUrl">
                        <a-input v-model:value="storageConfig.supabaseUrl"
                            placeholder="https://your-project.supabase.co" />
                    </a-form-item>
                    <a-form-item label="匿名密钥" name="supabaseKey">
                        <a-input-password v-model:value="storageConfig.supabaseKey" placeholder="匿名密钥" />
                    </a-form-item>
                    <a-form-item label="存储桶名称" name="bucketName">
                        <a-input v-model:value="storageConfig.bucketName" placeholder="存储桶名称" />
                    </a-form-item>
                </template>



                <!-- 腾讯云 COS 配置 -->
                <template v-if="storageConfig.provider === 'tencent'">
                    <a-divider>腾讯云 COS 配置</a-divider>
                    <a-form-item label="SecretId" name="secretId">
                        <a-input v-model:value="storageConfig.secretId" placeholder="SecretId" />
                    </a-form-item>
                    <a-form-item label="SecretKey" name="secretKey">
                        <a-input-password v-model:value="storageConfig.secretKey" placeholder="SecretKey" />
                    </a-form-item>
                    <a-form-item label="存储桶" name="bucketName">
                        <a-input v-model:value="storageConfig.bucketName" placeholder="存储桶名称" />
                    </a-form-item>
                    <a-form-item label="所属地域" name="region">
                        <a-input v-model:value="storageConfig.region" placeholder="ap-beijing" />
                    </a-form-item>
                    <a-form-item label="自定义域名" name="customDomain">
                        <a-input v-model:value="storageConfig.customDomain" placeholder="static.mahiru70.online" />
                        <template #extra>
                            <div style="color: #666; font-size: 12px;">
                                可选，如果配置了自定义域名，将使用此域名代替默认的COS域名
                            </div>
                        </template>
                    </a-form-item>
                </template>





                <!-- 测试连接 -->
                <a-form-item :wrapper-col="{ offset: 6, span: 18 }">
                    <a-space>
                        <a-button @click="testConnection" :loading="testing">
                            <ApiOutlined />
                            测试连接
                        </a-button>
                        <a-button type="primary" html-type="submit" :loading="saving">
                            <SaveOutlined />
                            保存配置
                        </a-button>
                    </a-space>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 分类存储配置 -->
        <a-card title="分类存储配置" class="storage-category-card">
            <a-row :gutter="[24, 24]">
                <!-- 头像存储 -->
                <a-col :xs="24" :md="6">
                    <div class="storage-category-item">
                        <h4 class="category-title">
                            <UserOutlined />
                            头像存储
                        </h4>
                        <a-form :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                            <a-form-item label="选择图床">
                                <a-select v-model:value="categoryConfig.avatar.provider" placeholder="选择图床">
                                    <a-select-option value="supabase">Supabase Storage</a-select-option>
                                    <a-select-option value="tencent">腾讯云 COS</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="存储主路径">
                                <a-input v-model:value="categoryConfig.avatar.path" placeholder="avatars/" />
                            </a-form-item>
                        </a-form>
                    </div>
                </a-col>

                <!-- 文章图片存储 -->
                <a-col :xs="24" :md="6">
                    <div class="storage-category-item">
                        <h4 class="category-title">
                            <FileImageOutlined />
                            文章图片存储
                        </h4>
                        <a-form :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                            <a-form-item label="选择图床">
                                <a-select v-model:value="categoryConfig.articleImages.provider" placeholder="选择图床">
                                    <a-select-option value="supabase">Supabase Storage</a-select-option>
                                    <a-select-option value="tencent">腾讯云 COS</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="存储主路径">
                                <a-input v-model:value="categoryConfig.articleImages.path"
                                    placeholder="articles/images/" />
                            </a-form-item>
                        </a-form>
                    </div>
                </a-col>

                <!-- 文章文件存储 -->
                <a-col :xs="24" :md="6">
                    <div class="storage-category-item">
                        <h4 class="category-title">
                            <FileOutlined />
                            文章文件存储
                        </h4>
                        <a-form :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                            <a-form-item label="选择图床">
                                <a-select v-model:value="categoryConfig.articleFiles.provider" placeholder="选择图床">
                                    <a-select-option value="supabase">Supabase Storage</a-select-option>
                                    <a-select-option value="tencent">腾讯云 COS</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="存储主路径">
                                <a-input v-model:value="categoryConfig.articleFiles.path"
                                    placeholder="articles/files/" />
                            </a-form-item>
                        </a-form>
                    </div>
                </a-col>

                <!-- 网站背景存储 -->
                <a-col :xs="24" :md="6">
                    <div class="storage-category-item">
                        <h4 class="category-title">
                            <BgColorsOutlined />
                            网站背景存储
                        </h4>
                        <a-form :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                            <a-form-item label="选择图床">
                                <a-select v-model:value="categoryConfig.siteBackground.provider" placeholder="选择图床">
                                    <a-select-option value="supabase">Supabase Storage</a-select-option>
                                    <a-select-option value="tencent">腾讯云 COS</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="存储主路径">
                                <a-input v-model:value="categoryConfig.siteBackground.path"
                                    placeholder="site/backgrounds/" />
                            </a-form-item>
                        </a-form>
                    </div>
                </a-col>
            </a-row>

            <!-- 保存分类配置按钮 -->
            <div class="category-actions">
                <a-button type="primary" @click="saveCategoryConfig" :loading="savingCategory">
                    <SaveOutlined />
                    保存分类配置
                </a-button>
            </div>
        </a-card>

    </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import {
    Card, Form, Input, Select, Button, Divider,
    Space, Row, Col
} from 'ant-design-vue'
import {
    SaveOutlined, ApiOutlined, UserOutlined,
    FileImageOutlined, FileOutlined, BgColorsOutlined
} from '@ant-design/icons-vue'
import supabaseSystemConfigService from '../../services/supabaseSystemConfigService'

export default {
    name: 'ObjectStorageManagement',
    components: {
        'a-card': Card,
        'a-form': Form,
        'a-form-item': Form.Item,
        'a-input': Input,
        'a-input-password': Input.Password,
        'a-select': Select,
        'a-select-option': Select.Option,
        'a-button': Button,
        'a-divider': Divider,
        'a-space': Space,
        'a-row': Row,
        'a-col': Col,
        SaveOutlined, ApiOutlined, UserOutlined,
        FileImageOutlined, FileOutlined, BgColorsOutlined
    },
    setup() {
        const saving = ref(false)
        const testing = ref(false)
        const savingCategory = ref(false)

        const storageConfig = reactive({
            provider: 'supabase',
            // Supabase
            supabaseUrl: '',
            supabaseKey: '',
            bucketName: '',
            // 腾讯云 COS
            secretId: '',
            secretKey: '',
            region: '',
            customDomain: ''
        })

        const categoryConfig = reactive({
            avatar: {
                provider: 'supabase',
                path: 'avatars/'
            },
            articleImages: {
                provider: 'supabase',
                path: 'articles/images/'
            },
            articleFiles: {
                provider: 'supabase',
                path: 'articles/files/'
            },
            siteBackground: {
                provider: 'supabase',
                path: 'site/backgrounds/'
            }
        })

        // 加载配置
        const loadConfig = async () => {
            try {
                // 加载存储配置
                const config = await supabaseSystemConfigService.getStorageConfig()
                if (config && Object.keys(config).length > 0) {
                    Object.assign(storageConfig, config)
                }

                // 加载分类配置
                const categoryConfigData = await supabaseSystemConfigService.getConfigValue('storage.category_config', {})
                if (categoryConfigData && Object.keys(categoryConfigData).length > 0) {
                    Object.assign(categoryConfig, categoryConfigData)
                }

                console.log('配置加载成功')
            } catch (error) {
                console.error('加载配置失败:', error)
                message.error('加载配置失败')
            }
        }

        // 处理存储服务提供商变更
        const handleProviderChange = (value) => {
            // 清空之前的配置，保留通用配置
            const commonConfig = {
                provider: value,
                bucketName: storageConfig.bucketName,
                pathPrefix: storageConfig.pathPrefix,
                maxFileSize: storageConfig.maxFileSize,
                allowedTypes: storageConfig.allowedTypes
            }
            Object.assign(storageConfig, commonConfig)
        }

        // 保存配置
        const saveConfig = async () => {
            try {
                saving.value = true
                await supabaseSystemConfigService.saveStorageConfig(storageConfig)
                message.success('配置保存成功')
            } catch (error) {
                console.error('保存配置失败:', error)
                message.error('保存配置失败')
            } finally {
                saving.value = false
            }
        }

        // 测试连接
        const testConnection = async () => {
            try {
                testing.value = true
                // TODO: 根据配置测试存储服务连接
                await new Promise(resolve => setTimeout(resolve, 2000)) // 模拟测试
                message.success('连接测试成功')
            } catch (error) {
                console.error('连接测试失败:', error)
                message.error('连接测试失败')
            } finally {
                testing.value = false
            }
        }

        // 保存分类配置
        const saveCategoryConfig = async () => {
            try {
                savingCategory.value = true
                await supabaseSystemConfigService.setConfig(
                    'storage.category_config',
                    categoryConfig,
                    'admin',
                    '分类存储配置'
                )
                message.success('分类配置保存成功')
            } catch (error) {
                console.error('保存分类配置失败:', error)
                message.error('保存分类配置失败')
            } finally {
                savingCategory.value = false
            }
        }

        onMounted(() => {
            loadConfig()
        })

        return {
            saving,
            testing,
            savingCategory,
            storageConfig,
            categoryConfig,
            handleProviderChange,
            saveConfig,
            testConnection,
            saveCategoryConfig
        }
    }
}
</script>

<style scoped>
.object-storage-management {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.storage-config-card,
.storage-category-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.storage-config-card :deep(.ant-card-head-title),
.storage-category-card :deep(.ant-card-head-title) {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
}

.storage-config-card :deep(.ant-form-item-label) {
    font-weight: 500;
}

.storage-category-item {
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 20px;
    height: 100%;
}

.category-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px 0;
    font-size: 16px;
    font-weight: 600;
    color: #262626;
}

.category-title .anticon {
    color: #1890ff;
}

.storage-category-item :deep(.ant-form-item) {
    margin-bottom: 16px;
}

.storage-category-item :deep(.ant-form-item-label) {
    font-weight: 500;
    color: #666;
}

.category-actions {
    margin-top: 24px;
    text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .storage-config-card :deep(.ant-form-item-label) {
        text-align: left;
    }

    .storage-config-card :deep(.ant-col-6) {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .storage-config-card :deep(.ant-col-18) {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>